import React, {  useState } from "react";
import Swal from "sweetalert2";
import { doLogin } from "../../api/auth.ts";
import { useAuthStore } from "../../store/auth.store.ts";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";
import forge from 'node-forge';
export default function LoginPage() {

  const setToken = useAuthStore(state => state.setToken);
  const setUsuario = useAuthStore(state => state.setUsuario);

  
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5cHZ4zreWh983kmDp1Mk
  /VFpQ+WdG8dFaYBhkpNkRLETRqrBCi6fq/bLxkbn4M8VOtLPNVw53oU6RS8sh2AH
  bJCiwNj1xgv/GsqDDHpP72CCZwEEYR9GiRn9ua41RyG6YK0dWyeN9WXK+C24oFeD
  ARB9D5fe/kFgyhZ+4dWctVMthN6XlYhHtPRyMqb6Z8StWJMGDTtFIJ5mApLB0UYN
  r63Mjkc1Ua357irP+Py6Zw1+hc3s6nEf6Ku/rQM5DjxMNG1ucFVFsSqvlSEcN9AU
  j4jN5om1GpZKpXIxkP39BvDzsVMEXGHMrtFmK0xCcJ+8Lo5K3MECWmB3LuSzqqmI
  6wIDAQAB
  -----END PUBLIC KEY-----
  `;



  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const handleInputChange = (
    e
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e => {
    e.preventDefault();
    
    const publicKeyObj = forge.pki.publicKeyFromPem(publicKeyPem);
    const encrypted = publicKeyObj.encrypt(formData.password, "RSA-OAEP");

    const encryptedPassword = forge.util.encode64(encrypted);
   
    doLogin(formData.email, encryptedPassword).then(res => {
      if (res.error === true) {
        Swal.fire({
          text: "El email o password incorrectos.",
          icon: "warning",
          confirmButtonText: "Ok"
        });
        return;
      }

      if (res.usuario && res.token) {
        window.localStorage.setItem("token", res.token);
        window.localStorage.setItem(
          "token-init-date",
          new Date().getTime().toString()
        );

        setToken(res.token);

        setUsuario({
          id: res.usuario.id,
          rut: res.usuario.rut,
          dv: res.usuario.dv,
          email: res.usuario.email,
          nombre: res.usuario.nombre,
          apellido: res.usuario.apellido,
          initial_password_modified: res.usuario.initial_password_modified,
          activo: res.usuario.activo,
          roles: res.usuario.roles
        });
      }
    });
  });

  
  return (
    <div className="mc-auth" translate="no">
     
      <img src="images/Login.png" alt="pattern" className="mc-auth-pattern mc-auth-pattern-desktop" />
      <img 
        src="images/Loginphone.png" 
        alt="pattern" 
        className="mc-auth-pattern mc-auth-pattern-mobile"
        onError={(e) => {
          // Fallback a la imagen desktop si la móvil no existe
          e.target.src = "images/Login.png";
        }}
      />
      <div className="mc-auth-group">
        <br></br>
         <br></br>
          <br></br>
           <br></br>
            <br></br>
             <br></br>
              <br></br>
               <br></br>
        <h4 className="mc-auth-title">&nbsp;</h4>
        <h4 className="mc-auth-title">&nbsp;</h4>
        <form className="mc-auth-form" onSubmit={handleSubmit} translate="no">
          <IconFieldComponent
            icon=""
            type="text"
            name="email"
            required
            classes="w-100 h-sm"
            placeholder="Ingrese su RUT o Email"
            onChange={handleInputChange}
          />
          <IconFieldComponent
            icon="lock"
            type="password"
            name="password"
            classes="w-100 h-sm"
            required
            placeholder="Ingrese su password"
            onChange={handleInputChange}
            passwordVisible={true}
          />

          <ButtonComponent className="mc-auth-btn h-sm" type="submit">
            Ingresar
          </ButtonComponent>
          <AnchorComponent className="mc-auth-forgot" to="/recuperar-password">
            Recuperar password
          </AnchorComponent>
        </form>
      </div>
    </div>
  );
}
